/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Message_PlaceholderInputs */

const en_contact_form_message_placeholder = /** @type {(inputs: Contact_Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us about the work, the problem or the system you have in mind…`)
};

const lv_contact_form_message_placeholder = /** @type {(inputs: Contact_Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastāstiet par darbu, problēmu vai sistēmu, kas Jums padomā…`)
};

/**
* | output |
* | --- |
* | "Tell us about the work, the problem or the system you have in mind…" |
*
* @param {Contact_Form_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_message_placeholder = /** @type {((inputs?: Contact_Form_Message_PlaceholderInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Message_PlaceholderInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_message_placeholder(inputs)
	return en_contact_form_message_placeholder(inputs)
});